import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { heroChips, heroTrust } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-88" data-mp="ei1unjxvvyww">
      <div className="bg-grid-lines absolute inset-0 opacity-60" aria-hidden="true" data-id="element-89" data-mp="9lbgx39jxfen" />

      <div className="relative mx-auto max-w-5xl px-5 pb-8 pt-4 text-center sm:pt-14" data-id="element-90" data-mp="4n1lqsntuet1">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-[10px] font-extrabold uppercase tracking-[0.25em] text-plata" style={{
        color: "#7FD4FF"
      }} data-id="element-91" data-mp="129qs1epkbdkp">
          🏆 SIGMA SMART™
        </motion.p>

        <p className="mx-auto mt-3 max-w-2xl font-display text-[22px] font-bold leading-tight text-white sm:text-[30px]" style={{
        fontSize: "30px",
        fontWeight: "800"
      }} data-id="element-92" data-mp="nb6llp1d5fmk">
          DEJA ATRAS LAS FRUSTRACIONES
DESBLOQUEA TODAS TUS METAS HOY


        </p>

        <motion.h1 initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-neon-azul pb-1 pt-1 font-display text-[26px] font-bold uppercase tracking-tight sm:text-5xl" data-id="element-93" data-mp="3j8iyd2s0imwa">
          NEURO-RUNNING PACK
        </motion.h1>

        

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto mt-2 w-full max-w-3xl" data-id="element-94" data-mp="3eb9150ydt6xw">
          <div className="absolute inset-x-8 bottom-4 -z-10 h-40 rounded-full bg-azul/25 blur-3xl" aria-hidden="true" data-id="element-95" data-mp="2qhqvxnkct20i" />
          <img src="https://cdn.magicpatterns.com/uploads/k18ZLSBLDc9AYEk5chdt3Z/ChatGPT_Image_14_ago_2026,_14_48_59.png" alt="Neuro-Running Pack — 12 tomos y 5 bonos en formato digital" className="animate-floaty mx-auto aspect-[3/2] w-full rounded-2xl object-contain" data-id="element-96" data-mp="2hj5czrayzkz7" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.3,
        delay: 0.05,
        ease: 'easeOut'
      }} className="mx-auto mt-5 max-w-2xl text-xs font-semibold uppercase tracking-[0.18em] text-white/50" style={{
        color: "#FFFFFF"
      }} data-id="element-97" data-mp="nbbcwylbob5a">
          EL SISTEMA N°1 DE PSICOLOGÍA DEPORTIVA PARA CORREDORES QUE QUIEREN DOMINAR SU MENTE.
        </motion.p>

        <div className="mt-8 flex flex-col items-center" data-id="element-98" data-mp="1ayt7t2zvvpch">
          <CTAButton href="#value" data-id="element-99" data-mp="162ugb6j9dr7u">⚡ Quiero el Neuro-Pack ahora</CTAButton>

          <p className="mx-auto mt-4 max-w-2xl text-[14px] text-white/70 sm:text-lg" data-id="element-100" data-mp="1126pakv15adm">
            Todo lo que necesitás para atravesar el muro, silenciar el autosabotaje, controlar los
            nervios pre-carrera y entrar en la zona. Sin improvisar. Sin abandonar. Sin depender de
            la motivación del día.
          </p>

          <motion.h2 initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.3,
          delay: 0.3,
          ease: 'easeOut'
        }} className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-plata sm:text-xl" data-id="element-101" data-mp="3hqkc6lpdzyuy">
            Neurobiología · Umbral del Dolor · Flow · Ansiedad · Visualización · Identidad
          </motion.h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-102" data-mp="2b1hjghg8ky9d">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-azul/25 bg-azul/10 px-3.5 py-1.5 text-xs font-semibold text-white/85" data-id="element-103" data-mp="2kyvn1gh29sk9">
                <Icon className="h-3.5 w-3.5 text-azul-soft" data-id="element-104" data-mp="2tzlgidiun6ut" />
                {label}
              </span>)}
          </div>

          <p className="mt-4 text-sm font-semibold text-white/50" data-id="element-105" data-mp="umzfvosefs46">
            12 Tomos · 5 Bonos · +100 páginas — Todo resuelto.
          </p>
        </div>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-white/50" data-id="element-106" data-mp="znn6wagmo8ye">
          {heroTrust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5 whitespace-nowrap" data-id="element-107" data-mp="3vhf9ttxq1dcw">
              <Icon className="h-4 w-4 text-plata" data-id="element-108" data-mp="e8sd9fg4cygx" />
              {label}
            </span>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.05,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-5 inline-flex items-center gap-2 rounded-full border border-naranja/50 bg-naranja/10 px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-naranja-soft" data-id="element-109" data-mp="98e41u2s7ihb">
          🔥 Oferta de lanzamiento cierra pronto · No vuelve a este precio
        </motion.div>
      </div>
    </header>;
}